import React from "react";
export default function TheShiftMission() {
  return <section data-section-id="236325" id="the-shift-mission" className="bg-background text-foreground py-24 md:py-32 lg:py-40 relative overflow-hidden">
      {}
      <div className="absolute inset-0 flex items-center justify-center pointer-events-none opacity-[0.03] select-none">
        <span className="font-serif text-[20vw] leading-none tracking-tighter rotate-90 md:rotate-0">
          SHIFT
        </span>
      </div>

      <div className="container mx-auto px-6 md:px-12 max-w-6xl relative z-10">
        {}
        <div className="mb-16 md:mb-24 flex justify-center">
          <span className="text-xs font-mono tracking-widest uppercase text-primary border-b border-primary pb-2">
            The Mission
          </span>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-x-16 lg:gap-x-32 gap-y-12">
          {}
          <div className="font-sans text-xl md:text-2xl leading-relaxed text-foreground">
            <span className="float-left text-7xl md:text-8xl leading-none font-serif text-primary pr-4 pt-2">
              S
            </span>
            hift was founded on a simple premise: moving shouldn't be a source of stress. We approach every relocation with kinetic precision, ensuring that your transition to a new home or office is as seamless as it is professional.
          </div>

          {}
          <div className="font-sans text-xl md:text-2xl leading-relaxed text-muted-foreground">
            Our team is built on a foundation of industrial strength and digital sophistication. We combine heavy-duty logistics with modern tracking technology to provide a moving experience that is transparent, punctual, and entirely personalized.
          </div>

          {}
          <div className="col-span-1 md:col-span-2 py-16 md:py-24 flex justify-center">
            <blockquote className="text-center max-w-4xl">
              <p className="font-serif text-3xl md:text-4xl lg:text-5xl leading-tight text-secondary uppercase tracking-tight">
                "We don't just move boxes; we move lives with care, speed, and absolute reliability."
              </p>
            </blockquote>
          </div>

          {}
          <div className="font-sans text-xl md:text-2xl leading-relaxed text-foreground">
            Whether you are moving across the street or across the state, our commitment to safety remains unwavering. We utilize fully equipped trucks and experienced staff who treat every item as if it were their own most valuable asset.
          </div>

          {}
          <div className="font-sans text-xl md:text-2xl leading-relaxed text-muted-foreground">
            This deliberate approach allows us to deliver stress-free results every time. We invite you to experience a partnership where logistical expertise meets genuine customer care, framed by the efficiency that defines the Shift standard.
          </div>
        </div>
      </div>
    </section>;
}